// --- Modules
import Node, { payload } from './Node';

class Firewall extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Firewall'
    });
  }
};

export default {
  create: (opts) => {
    let item = new Firewall(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
